import { P } from "theme/typography";
import Flex from "./Flex";
import { Button } from "@mui/material";
import { useRouteError } from "react-router";

interface PatternErrorProps {
  message?: string;
}

const PatternError = ({ message }: PatternErrorProps) => {
  const error = useRouteError();
  console.error(error);
  return (
    <Flex centered>
      <P sx={{ mb: 2 }} variant="h4">
        Something went wrong. Try reloading the page
      </P>
      {message && <P variant="body2">{message}</P>}
      <Button onClick={() => window.location.reload()}>Reload</Button>
    </Flex>
  );
};

export default PatternError;
